import { lazy } from 'react';

export const CreateProject = lazy(() => import('./CreateProject'));

export default CreateProject;
